import { render, staticRenderFns } from "./LoyaltyPuntosColombia.vue?vue&type=template&id=5c12362c"
import script from "./LoyaltyPuntosColombia.vue?vue&type=script&lang=js"
export * from "./LoyaltyPuntosColombia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/mahalo_integrador/hiopos/reports-co/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c12362c')) {
      api.createRecord('5c12362c', component.options)
    } else {
      api.reload('5c12362c', component.options)
    }
    module.hot.accept("./LoyaltyPuntosColombia.vue?vue&type=template&id=5c12362c", function () {
      api.rerender('5c12362c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/app/administration/components/LoyaltyConfig/LoyaltyPuntosColombia.vue"
export default component.exports